"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Drawer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Drawer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Drawer, _Component);

  var _super = _createSuper(Drawer);

  function Drawer() {
    var _this;

    (0, _classCallCheck2.default)(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          anchor = _this$props.anchor,
          children = _this$props.children,
          classes = _this$props.classes,
          onClose = _this$props.onClose,
          open = _this$props.open,
          variant = _this$props.variant,
          ModalProps = _this$props.modalProps,
          className = _this$props.className,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["id", "anchor", "children", "classes", "onClose", "open", "variant", "modalProps", "className"]);
      return /*#__PURE__*/_react.default.createElement(_Drawer.default, (0, _extends2.default)({
        id: id,
        className: "prmbl-drawer ".concat(className),
        anchor: anchor,
        classes: classes,
        ModalProps: ModalProps,
        onClose: onClose,
        open: open,
        variant: variant
      }, otherProps), children);
    });
    return _this;
  }

  return Drawer;
}(_react.Component);

exports.Drawer = Drawer;
(0, _defineProperty2.default)(Drawer, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Side from which the drawer will appear
   */
  anchor: _propTypes.default.oneOf(["left", "top", "right", "bottom"]),

  /**
   * The contents of the drawer
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   *
   * Utilized By:
   * Preamble => Page
   */
  classes: _propTypes.default.object,

  /**
   * @ignore
   *
   * Utilized By:
   * Preamble => Page
   */
  modalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed
   */
  onClose: _propTypes.default.func,

  /**
   * If 'true', the drawer is open.
   */
  open: _propTypes.default.bool,

  /**
   * The variant to use
   */
  variant: _propTypes.default.oneOf(["permanent", "persistent", "temporary"]),

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(Drawer, "defaultProps", {
  variant: "temporary",
  className: ""
});
var _default = Drawer;
exports.default = _default;